import React, { useState, useEffect } from 'react';
import { Tabs, Container } from './style';
import ProfilePage from './Profile';
import { MainLayout } from '@design-system/Layout';
import TransactionHistory from './transactionHistory';
import { useParams } from 'react-router-dom';

const data = [
  {
    id: 1,
    tab_title: 'Profile',
    content: <ProfilePage />,
  },
  {
    id: 2,
    tab_title: 'Transaction History',
    content: <TransactionHistory />,
  },
];

const Profile = () => {
  const [visibileTab, setVisibleTab] = useState(data[0].id);
  const params = useParams();

  useEffect(() => {
    if (params.id === 'profile') {
      setVisibleTab(data[0].id);
    } else {
      setVisibleTab(data[1].id);
    }
  }, [params]);

  const listTitles = data.map((item) => (
    <li
      key={item.id}
      onClick={() => setVisibleTab(item.id)}
      className={visibileTab === item.id ? 'tab_active' : 'tab'}
    >
      {' '}
      {item.tab_title}
    </li>
  ));
  const listContent = data.map((item) => (
    <div key={item.id} className={visibileTab === item.id ? '' : 'content'}>
      {item?.content}
    </div>
  ));

  return (
    <MainLayout>
      <Container>
        <div className="header">Account</div>
        <Tabs>
          <ul className="tab_title">{listTitles}</ul>
          <div className="tab_content">{listContent}</div>
        </Tabs>
      </Container>
    </MainLayout>
  );
};

export default Profile;
